import { render, staticRenderFns } from "./RoomDetail.vue?vue&type=template&id=16314edc&scoped=true"
import script from "./RoomDetail.vue?vue&type=script&lang=js"
export * from "./RoomDetail.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/roomdetail.css?vue&type=style&index=0&id=16314edc&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16314edc",
  null
  
)

export default component.exports